import { Component, OnChanges, SimpleChanges, Input, TemplateRef, ContentChild, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MatIcon } from '@angular/material/icon';
import { NgClass, NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'lc-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  imports: [
    MatIcon,
    NgClass,
    NgTemplateOutlet,
  ],
})
export class BannerComponent implements OnChanges {
  private sanitizer = inject(DomSanitizer);

  @Input()
    message: string;

  @Input()
    level: 'info' | 'warn' | 'error';

  @ContentChild(TemplateRef)
    template: TemplateRef<any>;

  html: SafeHtml;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.message) {
      this.html = this.sanitizer.bypassSecurityTrustHtml(this.message);
    }
  }
}
